import { Timeline } from 'antd'
import {
  ReadOutlined,
  FileAddOutlined,
  LoadingOutlined,
  BulbOutlined,
  FireOutlined,
  DesktopOutlined,
  RiseOutlined,
} from '@ant-design/icons'
import React from 'react'
import moment from 'moment'
import './timeLine.css'
import TitleD from '../title/Title'
import DateCreator from '../date/dateCreator'

const dataStory = [
  {
    icon: <ReadOutlined />,
    color: 'blue',
    text: 'ДГТУ. Прикладная информатика. Бакалавр.',
    date: (
      <DateCreator
        from="2013"
        to="2017"
        dateFormat="YYYY"
        picker="year"
        style={{ width: 140 }}
      />
    ),
  },
  {
    icon: <FileAddOutlined />,
    color: 'green',
    text: 'ДГТУ. Прикладная информатика. Магистр.',
    date: (
      <DateCreator
        from="2017"
        to="2019"
        dateFormat="YYYY"
        picker="year"
        style={{ width: 140 }}
      />
    ),
  },
  {
    icon: <BulbOutlined />,
    color: 'blue',
    text: 'DATUM Group. Инженер-программист 4 кат.',
    date: (
      <DateCreator
        from="10/07/2019"
        to="01/10/2019"
        dateFormat="DD/MM/YYYY"
        picker="all"
        style={{ width: 220 }}
      />
    ),
  },
  {
    icon: <DesktopOutlined />,
    color: 'gray',
    text: 'DATUM Group. Инженер-программист 3 кат.',
    date: (
      <DateCreator
        from="01/10/2019"
        to="29/05/2020"
        dateFormat="DD/MM/YYYY"
        picker="all"
        style={{ width: 220 }}
      />
    ),
  },
  {
    icon: <RiseOutlined />,
    color: 'blue',
    text: 'DATUM Group. Менеджер проекта 3 кат.',
    date: (
      <DateCreator
        from="29/05/2020"
        to="31/07/2020"
        dateFormat="DD/MM/YYYY"
        picker="all"
        style={{ width: 220 }}
      />
    ),
  },
  {
    icon: <FireOutlined />,
    color: 'red',
    text: 'DATUM Group. Менеджер проекта 2 кат.',
    date: (
      <DateCreator
        from="31/07/2020"
        to="23/03/2021"
        dateFormat="DD/MM/YYYY"
        picker="all"
        style={{ width: 220 }}
      />
    ),
  },
  {
    icon: <LoadingOutlined />,
    color: 'purple',
    text: ' Изучение React.',
    date: (
      <DateCreator
        from="23/03/2021"
        to={moment().format('DD-MM-YYYY')}
        dateFormat="DD/MM/YYYY"
        picker="all"
        style={{ width: 220 }}
      />
    ),
  },
]

const TimelineStory = () => (
  <>
    <TitleD text="Образование/Работа" size="5" />
    <Timeline className="TimelineStory">
      {dataStory.map(
        ({ icon, color, text, date }, index) => (
          <Timeline.Item
            dot={icon}
            color={color}
            key={index}
          >
            {text} {date}
          </Timeline.Item>
        )
      )}
    </Timeline>
  </>
)

export default TimelineStory
